import { render, staticRenderFns } from "./Forgot_password.vue?vue&type=template&id=e1376b52&scoped=true"
import script from "./Forgot_password.vue?vue&type=script&lang=js"
export * from "./Forgot_password.vue?vue&type=script&lang=js"
import style1 from "./Forgot_password.vue?vue&type=style&index=1&id=e1376b52&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1376b52",
  null
  
)

export default component.exports